import React, { useState } from 'react';
import { MagnifyingGlass, MapPin } from 'phosphor-react';
import { SLabel } from '@/components/ui/atoms/SLabel';
import { SInputField } from '@/components/ui/molecules/SInputField';
import { SNavigationButton } from '@/components/ui/atoms/SNavigationButton';
import { SFooterDrawer } from '@/components/ui/organisms/SFooterDrawer';
import './SelectCountryDrawer.css';

export interface SelectCountryDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  currentCountry?: string;
  onCountrySelect?: (country: string) => void;
}

/** Shared with v2's Personal screen — one list, not two. */
export const countries = [
  'United States',
  'Canada',
  'United Kingdom',
  'Australia',
  'Germany',
  'France',
  'Italy',
  'Spain',
  'Netherlands',
  'Belgium',
  'Switzerland',
  'Austria',
  'Sweden',
  'Norway',
  'Denmark',
  'Finland',
  'Ireland',
  'Portugal',
  'Greece',
  'Poland',
  'Czech Republic',
  'Hungary',
  'Romania',
  'Bulgaria',
  'Croatia',
  'Slovakia',
  'Slovenia',
  'Estonia',
  'Latvia',
  'Lithuania',
  'Mexico',
  'Brazil',
  'Argentina',
  'Chile',
  'Colombia',
  'Peru',
  'Venezuela',
  'Ecuador',
  'Uruguay',
  'Paraguay',
  'Bolivia',
  'Costa Rica',
  'Panama',
  'Guatemala',
  'Honduras',
  'El Salvador',
  'Nicaragua',
  'Dominican Republic',
  'Puerto Rico',
  'Jamaica',
  'Trinidad and Tobago',
  'Bahamas',
  'Barbados',
  'Japan',
  'China',
  'South Korea',
  'India',
  'Singapore',
  'Malaysia',
  'Thailand',
  'Indonesia',
  'Philippines',
  'Vietnam',
  'Taiwan',
  'Hong Kong',
  'New Zealand',
  'South Africa',
  'Egypt',
  'Morocco',
  'Kenya',
  'Nigeria',
  'Ghana',
  'Israel',
  'United Arab Emirates',
  'Saudi Arabia',
  'Qatar',
  'Kuwait',
  'Bahrain',
  'Oman',
  'Jordan',
  'Lebanon',
  'Turkey',
  'Russia',
  'Ukraine',
  'Kazakhstan',
];

export const SelectCountryDrawer: React.FC<SelectCountryDrawerProps> = ({
  isOpen,
  onClose,
  currentCountry = 'United States',
  onCountrySelect,
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredCountries = countries.filter((country) =>
    country.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleCountrySelect = (country: string) => {
    if (onCountrySelect) {
      onCountrySelect(country);
    }
    onClose();
  };

  return (
    <SFooterDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Select Country"
      height="85%"
    >
      <div className="select-country-drawer-content">
        {/* Search Input */}
        <div className="select-country-search">
          <SInputField
            size="m"
            state="default"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            showIcon={true}
            icon={<MagnifyingGlass size={20} color="#696D77" />}
            iconPosition="right"
          />
        </div>

        {/* Current Country */}
        {currentCountry && (
          <div className="select-country-current-section">
            <SNavigationButton
              leftIcon={<MapPin size={24} color="#BD9734" />}
              label={currentCountry}
              subLabel="Current Country"
            />
          </div>
        )}

        {/* Other Countries Label */}
        <div className="select-country-other-label">
          <SLabel>Other Countries</SLabel>
        </div>

        {/* Countries List */}
        <div className="select-country-list">
          {filteredCountries.map((country) => (
            <SNavigationButton
              key={country}
              label={country}
              onClick={() => handleCountrySelect(country)}
            />
          ))}
        </div>
      </div>
    </SFooterDrawer>
  );
};

export default SelectCountryDrawer;
